import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Card,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  makeStyles,
  TablePagination
} from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import IconButton from '@material-ui/core/IconButton';

const useStyles = makeStyles((theme) => ({
  root: {},
  avatar: {
    marginRight: theme.spacing(2)
  }
}));

const Results = ({
  className,
  menus,
  onRemove,
  onChangePage,
  page,
  totalMenus
}) => {
  const classes = useStyles();
  const navigate = useNavigate();

  return (
    <Card className={clsx(classes.root, className)}>
      <PerfectScrollbar>
        <Box minWidth={1050}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Titulo</TableCell>
                <TableCell>Marca</TableCell>
                <TableCell>url</TableCell>
                <TableCell width={150} align="center">Ações</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {menus.map((menu) => (
                <TableRow
                  hover
                  key={menu._id}
                >
                  <TableCell>
                    <Box alignItems="center" display="flex">
                      <Typography color="textPrimary" variant="body1">
                        {menu.titlePT}
                      </Typography>
                    </Box>
                  </TableCell>
                  <TableCell>{menu.brand}</TableCell>
                  <TableCell>{menu.url}</TableCell>
                  <TableCell align="center">
                    <IconButton aria-label="edit" onClick={() => navigate(`edit/${menu._id}`)}>
                      <EditIcon />
                    </IconButton>
                    <IconButton aria-label="delete" onClick={() => onRemove(menu._id)}>
                      <DeleteIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Box>
      </PerfectScrollbar>
      <TablePagination
        component="div"
        count={totalMenus}
        page={page}
        onChangePage={(event, newPage) => onChangePage(newPage)}
        rowsPerPage={10}
        rowsPerPageOptions={[10]}
      />
    </Card>
  );
};

Results.propTypes = {
  className: PropTypes.string,
  menus: PropTypes.array.isRequired,
  page: PropTypes.number.isRequired,
  totalMenus: PropTypes.number.isRequired,
  onRemove: PropTypes.func.isRequired,
  onChangePage: PropTypes.func.isRequired
};

export default Results;
